import React from "react";

import { Metric } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

const MarqueeTVWatchingSummary = (props) => {
  const { data } = props;

  return (
    <div className="row mt-2 d-flex align-items-end">
      {data.subscribers_watching && (
        <div className="col-6 col-md-3 mb-3">
          <Heading size={6} className="mb-1">
            % of Subscribers Watching
          </Heading>
          <Metric
            {...data.subscribers_watching}
            size="md"
            type="percentage"
            format="0.00%"
          />
        </div>
      )}

      {data.viewers_free_trial && (
        <div className="col-6 col-md-3 mb-3">
          <Heading size={6} className={"mb-1"}>
            Viewers on Free Trial
          </Heading>
          <Metric {...data.viewers_free_trial} size={"md"} />
        </div>
      )}

      {data.annual_plan_viewers && (
        <div className="col-6 col-md-3 mb-3">
          <Heading size={6} className={"mb-1"}>
            Annual Plan Viewers
          </Heading>
          <Metric {...data.annual_plan_viewers} size={"md"} />
        </div>
      )}

      {data.monthly_plan_viewers && (
        <div className="col-6 col-md-3 mb-3">
          <Heading size={6} className={"mb-1"}>
            Monthly Plan Viewers
          </Heading>
          <Metric {...data.monthly_plan_viewers} size={"md"} />
        </div>
      )}
    </div>
  );
};

export default MarqueeTVWatchingSummary;
